import { Component, OnInit, ChangeDetectionStrategy,AfterViewInit,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup, Validators, MinLengthValidator} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";
// import { BA1340ervice } from 'src/app/core/_base/_service/_admin/ba1340.service';
import{ba1110Service}from '../../../../../Service/ba1110/ba1110-service.service'
import{Ba1110Class}from '../../../../../Class/ba1110/ba1110-class'
import { from } from 'rxjs';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import { LayoutUtilsService } from 'src/app/core/_base/crud';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'kt-ba1110-change',
  templateUrl: './ba1110-change.component.html',
  styleUrls: ['./ba1110-change.component.scss']
})
export class Ba1110ChangeComponent implements OnInit,AfterViewInit {
  Form:FormGroup;
  closeResult: string;
  MandatoryStatus: string;

  lblPageTitle: string = "";
  lblSave: string;
  lblConfirmTran: string;
  lblUserNam: string;
  lblUserLgnPwd: string;
  lblUserTrnPwd: string;
  lblBack: string;
  lblFkEmpId:string;
  lblConfirm:string;
  CtrlNames:any[];
  lblMandatory: string;
  lblSystemError: string;
  UserName:any[];
  Errors:any[];
  showTransactionPassword = false;
  showConfirmTransactionPassword = false;
  showLoginPwd = false;
  showConfirmPwd = false;
  constructor(private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
   private userservice:ba1110Service,public dialog: MatDialog,public dialogRef: MatDialogRef<Ba1110ChangeComponent>,private layoutUtilsService: LayoutUtilsService,private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef ) {
		// customize default values of tabsets used by this component tree
		// config.justify = 'center';
		// config.type = 'pills';
	}
	ngOnInit() {
  
    this.Form = this.formBuilder.group({
      UserId: [0],
      UserNam: ['', Validators.required],
      UserLgnPwd: ['', Validators.required],
      Confirm: ['', Validators.required],
      UserTrnPwd: ['', Validators.required],
      ConfirmTran: ['', Validators.required]
    });
    this.Errors=[];
    this.onGetCommonControlNames();
    this.onGetControlNames();
    this.onGetUserName();
  }
    ngAfterViewInit()
    {
  }

  onGetUserName()
{
  this.userservice.GetUserName().subscribe(list=>{
    
    this.Form.controls["UserNam"].setValue(list.UserNam);
    })
}
  onSave(mode)
  {


    const loginPwd = this.Form.controls["UserLgnPwd"].value;

  this.Form.controls["UserTrnPwd"].setValue(loginPwd);
  this.Form.controls["ConfirmTran"].setValue(loginPwd);

  this.showTransactionPassword = false;
  this.showConfirmTransactionPassword = false;

    this.MandatoryStatus = "";
    this.onMandatoryCheck();
    if(this.MandatoryStatus != "")
    {
      this.layoutUtilsService.showActionNotification( this.lblMandatory + " : " + this.MandatoryStatus, MessageType.Read, 5000, true, false, 5000, "bottom");
      return;
    }
    if((this.Form.controls["UserLgnPwd"].value) !=(this.Form.controls["Confirm"].value ))
    {
      this.layoutUtilsService.showActionNotification("Passwords must match", MessageType.Read);
      return;
    }
    // else if((this.Form.controls["UserTrnPwd"].value) !=(this.Form.controls["ConfirmTran"].value) )
    // {
    //   this.layoutUtilsService.showActionNotification("Passwords must match", MessageType.Read);
    //   return;
    // }
    else if(this.Form.controls["UserLgnPwd"].value.length< 3)
    {
      this.layoutUtilsService.showActionNotification("Login Password must contain atleast 3 characters", MessageType.Read);
      return;
    }
    // else if(this.Form.controls["UserTrnPwd"].value.length< 3)
    // {
    //   this.layoutUtilsService.showActionNotification("Transaction Password must contain atleast 3 characters", MessageType.Read);
    //   return;
    // }
    
    else
    {
    var classobj=new Ba1110Class();
    classobj.UserLgnPwd=this.Form.controls["UserLgnPwd"].value;
    classobj.UserTrnPwd=this.Form.controls["UserTrnPwd"].value;
    var ob=this.Form.value;
    this.userservice.ChangePwd(classobj).subscribe(data=>{

    if(data.IsSuccess)
    {
      if(mode==1 )
      {
            // this.router.navigate(['widget/widget-dashboard/4']);
      }
     
    }
  })
    this.dialogRef.close();

}
}
  
  onMandatoryCheck()
  {
    if(this.Form.controls["UserNam"].value.trim() == "")
    {
      document.getElementById("UserNam").focus();
      
      this.MandatoryStatus=this.lblUserNam;
      
      return;
    }
    
    if(this.Form.controls["UserLgnPwd"].value.trim() == "")
    {
      document.getElementById("UserLgnPwd").focus();
      this.MandatoryStatus=this.lblUserLgnPwd;
      return;
    }
    if(this.Form.controls["UserTrnPwd"].value.trim() == "")
    {
      document.getElementById("UserTrnPwd").focus();
      
      this.MandatoryStatus=this.lblUserTrnPwd;
      return;
    }
     
  }
  onGetCommonControlNames()
  {
    this.userservice.GetCommonControlNames(63).subscribe(CommonControlNamesList=>{
      CommonControlNamesList.forEach(data => {
       
        if(data.GeneralMsgId == 0)
        {
          this.lblPageTitle = data.Message;
        }
        else if(data.GeneralMsgId == 10)
        {
          this.lblSave = data.Message;
        }
        else if (data.GeneralMsgId == 7) {
					this.lblBack = data.Message;
				} 
        else if(data.GeneralMsgId == 28)
        {
          this.lblMandatory = data.Message;
        }
        else if(data.GeneralMsgId == 29)
        {
          this.lblSystemError = data.Message;
        }
      });
      this.changeDetectorRef.detectChanges();
    })
  }

  onGetControlNames()
  {
    
    this.userservice.GetControlNames().subscribe(ControlNamesList=>{
      console.log(ControlNamesList);

      ControlNamesList.forEach(data => {
        if(data.ElementID =="UserNam")
        {
          this.lblUserNam = data.ElementText;
        }
        else if(data.ElementID =="UserLgnPwd")
        {
          this.lblUserLgnPwd = data.ElementText;
        }
        else if(data.ElementID =="Confirm")
        {
          this.lblConfirm = data.ElementText;
        }
        else if(data.ElementID =="UserTrnPwd")
        {
          this.lblUserTrnPwd = data.ElementText;
        }
        else if(data.ElementID =="ConfirmTran")
        {
          this.lblConfirmTran = data.ElementText;
        }
      });
      this.changeDetectorRef.detectChanges();
    })
  }

  onBack()
  {
    this.router.navigateByUrl('/hrms');
  }
   getComponentTitle()
  {
   let result = this.lblPageTitle;
   return result;
 }
  LoadData(UserNam)
    {
      var VarUserNam = (document.getElementById("UserNam")) as HTMLFormElement;
      UserNam.disabled =true;
    }

toggleLoginPwd() {
  this.showLoginPwd = !this.showLoginPwd;
}
toggleConfirmPwd() {
  this.showConfirmPwd = !this.showConfirmPwd;
}
	goBack() {
     this.dialogRef.close();
	// this.router.navigate(['widget/widget-dashboard/4']);
	}

}
